import React, { Suspense } from 'react';
import Spinners from '../spinners/Spinners';

export default function RenderSuspense(props) {
    return <Suspense fallback={<Spinners />}>
        {props.children}
    </Suspense>
}